import { atom } from "recoil";

const homeLinkAtom = atom({
  key: "homeLinkState",
  default: false,
});

export default homeLinkAtom;
